import React from 'react';
import Modal from 'react-modal';

const ProductAddChoiceModal = ({ isOpen, openSavedLinksModal, openAddProductModal, toggle }) => {
    const handleAddByUrl = () => {
        toggle(); // close this
        openAddProductModal(); // then open add product
    };

    const handleAddFromSaved = () => {
        toggle(); // close this
        openSavedLinksModal(); // then open the other
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={toggle}
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 9998,
                },
                content: {
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    border: '1px solid #ccc',
                    background: '#fff',
                    borderRadius: '8px',
                    padding: '30px',
                    width: '300px',
                    textAlign: 'center',
                    height: "388px"
                }
            }}
        >
            <h4 style={{ textAlign: "left" }}>Add New Product</h4>
            <div className="d-flex flex-column justify-content-center" style={{ gap: '35px', textAlign: "left", height: "85%" }}>
                <div className="post-add-product-modal-selection position-relative" style={{ border: "1px solid lightgray", borderRadius: "15px", cursor: "pointer", padding: "10px" }} onClick={handleAddFromSaved}>
                    <h4 style={{ fontSize: "16px", fontWeight: "500", marginBottom: "7px" }}>Search Products</h4>
                    <p style={{ fontSize: "12px" }}>
                        Search your saved products and add the ones that fit your post                    
                    </p>
                    <p className="position-absolute" style={{ top: "-9px", right: "11px", border: "1px solid lightgray", fontWeight: "bold", fontSize: "10px", borderRadius: "15px", padding: "0 10px", zIndex: 1, background: "white" }}>
                        Most Popular
                    </p>
                </div>
                <div className="post-add-product-modal-selection" style={{ border: "1px solid lightgray", borderRadius: "15px", cursor: "pointer", padding: "10px" }} onClick={handleAddByUrl}>
                    <h4 style={{ fontSize: "16px", fontWeight: "500", marginBottom: "7px" }}>Add by URL</h4>
                    <p style={{ fontSize: "12px" }}>
                        Copy and paste a URL from any online brand supported by RockPorch
                    </p>
                </div>
            </div>
            <button
                onClick={toggle}
                style={{
                    position: 'absolute',
                    top: '10px',
                    right: '15px',
                    background: 'transparent',
                    border: 'none',
                    fontSize: '1.5rem',
                    cursor: 'pointer',
                }}
                aria-label="Close modal"
            >
                &times;
            </button>
        </Modal>
    );
};

export default ProductAddChoiceModal;
